export default "__VITE_ASSET__830b9kcQ__"